import { formatMoney } from '@/lib/format'

import tableStyles from '../components/Table.module.css'
import type { DeptTxn } from '../lib/filterTxns'

interface TxnTableProps {
  rows: DeptTxn[]
  showDept: boolean
  deptName: (code: string) => string
}

export function TxnTable({ rows, showDept, deptName }: TxnTableProps) {
  return (
    <table className={`${tableStyles.table} ${tableStyles.txn}`}>
      <thead>
        <tr>
          <th className={tableStyles.left} scope="col">
            Date
          </th>
          {showDept ? (
            <th className={tableStyles.left} scope="col">
              Dept
            </th>
          ) : null}
          <th className={tableStyles.left} scope="col">
            Account
          </th>
          <th className={tableStyles.left} scope="col">
            Who / description
          </th>
          <th scope="col">Doc #</th>
          <th scope="col">Amount</th>
        </tr>
      </thead>
      <tbody>
        {rows.map((row, i) => (
          <tr key={`${row.dept}-${row.doc}-${row.acct}-${i}`}>
            <td className={`${tableStyles.left} ${tableStyles.date}`}>{row.date}</td>
            {showDept ? <td className={tableStyles.left}>{deptName(row.dept)}</td> : null}
            <td className={tableStyles.left}>
              {row.acct} — {row.title}
            </td>
            <td className={`${tableStyles.left} ${tableStyles.wrap} ${tableStyles.muted}`}>
              {row.who || row.desc || '—'}
              {row.who && row.desc ? <span className="text-faint"> · {row.desc}</span> : null}
            </td>
            <td className="num">{row.doc || '—'}</td>
            <td className="num">{formatMoney(row.amt, { cents: true })}</td>
          </tr>
        ))}
      </tbody>
    </table>
  )
}
